import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrepareGuard, AuthGuard } from 'app/core/core.module';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { AuctionOverviewComponent } from './auction-overview/auction-overview.component';
import { PaddleDialogComponent } from './paddle-dialog/paddle-dialog.component';
import { AuctionPurchaseDialogComponent } from './auction-purchase-dialog/auction-purchase-dialog.component';
import { AuctionItemDialogComponent } from './auction-item-dialog/auction-item-dialog.component';
import { PurchaseOverviewComponent } from './purchase-overview/purchase-overview.component';
import { InvoiceOverviewComponent } from './invoice-overview/invoice-overview.component';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { InvoiceLineDialogComponent } from './invoice-line-dialog/invoice-line-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'invoices',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'list', pathMatch: 'full' },
                    { path: 'auction', component: AuctionOverviewComponent, data: { title: 'Auction Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'purchases', component: PurchaseOverviewComponent, data: { title: 'Purchase Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    { path: 'overview', component: InvoiceOverviewComponent, data: { title: 'Invoice Overview' }, canActivate: [AuthGuard, PrepareGuard] },
                    {
                        path: ':id',
                        component: InvoiceDetailComponent,
                        data: { title: 'Invoice Detail' },
                        canActivate: [AuthGuard, PrepareGuard],
                    },
                ],
            },
        ]),
    ],
    exports: [],
})
export class InvoicesModule {}
